import EnterNewAddressView from './EnterNewAddressView';

export default EnterNewAddressView;
